// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".question .question__title p{display:inline;padding:0;margin:0}.question .separator{height:50%;border-top:1px solid gray;min-width:32px;margin-right:10px}.question .separator.disabled{border-color:#e6e6e6}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
